module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-12.jpg?v=6945c3f6";